import { render, staticRenderFns } from "./ProductDetailsLoader.vue?vue&type=template&id=272a1b8e&"
import script from "./ProductDetailsLoader.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports